export function responsiveTable() {
	const tableEls = document.querySelectorAll(".tinyMceText table");

	tableEls.forEach(el => {
		let wrapper = document.createElement('div');
		wrapper.classList.add("table-wrap");
		el.parentNode.insertBefore(wrapper, el);
		wrapper.appendChild(el);
	})
}
